import classNames from 'classnames';
import React from 'react';
import { Tr as ResponsiveTr } from 'react-super-responsive-table';
import { notNull } from 'utils/typesafe';
import styles from './index.module.scss';

export interface TrProps extends React.HTMLAttributes<HTMLTableRowElement> {
  compact?: boolean;
  depth?: number;
  interactive?: boolean;
  selected?: boolean;
  /** Subtle background effect to indicate status of row */
  variant?: 'danger' | 'success';
}

export const Tr: React.FC<TrProps> = props => {
  const { className, compact, interactive, selected, variant, ...rest } = props;
  const hasVariant = !!variant;
  const containerClass = classNames(
    styles.tr,

    {
      [styles[`variant-${variant}`]]: hasVariant,
      [styles.compact]: compact,
      [styles.interactive]: interactive,
      [styles.withBgColor]: selected || hasVariant,
      [styles.selected]: selected,
    },
    className
  );
  // Ref ReportTableBody, ReportTableHead, etc can return falsy children,
  // which breaks the components. Not 100% clear on why, but this fixes it:
  const children =
    Array.isArray(props.children) && props.children.length
      ? props.children.filter(notNull)
      : props.children;
  return (
    <ResponsiveTr {...rest} className={containerClass} data-testid="table-rows-index">
      {children}
    </ResponsiveTr>
  );
};
